module.exports = __webpack_public_path__ + "img/papir@2x.d283b2e4.webp";